import {
  CATALOG_LIST_BODY_ASPECT,
  CATALOG_LIST_COVER_ASPECT,
  CATALOG_LIST_GRID_CLASS,
} from './catalogListGrid'
import { catalogListCardLinkClass } from './catalogListCardShell'

/** 目录列表加载占位（全宽网格 · 与统一卡片比例一致） */
export function CatalogListSkeleton({ count = 8 }: { count?: number }) {
  return (
    <ul className={CATALOG_LIST_GRID_CLASS}>
      {Array.from({ length: count }, (_, i) => (
        <li key={i} className="animate-pulse">
          <div className={catalogListCardLinkClass('hover:translate-y-0')}>
            <div className={`${CATALOG_LIST_COVER_ASPECT} bg-zinc-900/90`} />
            <div className={`${CATALOG_LIST_BODY_ASPECT} flex flex-col justify-between px-3 py-2`}>
              <div className="space-y-1">
                <div className="h-3.5 w-[78%] rounded bg-zinc-800" />
                <div className="h-2.5 w-full rounded bg-zinc-800/70" />
              </div>
              <div className="flex items-center justify-between pt-1">
                <div className="h-2.5 w-1/2 rounded bg-zinc-800/60" />
                <div className="h-2.5 w-12 rounded bg-zinc-800/50" />
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}
